export default "__VITE_ASSET__e4983fae__"